import React, { Fragment, useEffect, useState } from "react";

import { Switch, Chip, IconButton } from "@material-ui/core/";
import { Delete as DeleteIcon, Edit as EditIcon, LiveTv as LiveTvIcon } from "@material-ui/icons/";

import NavBar from "../../components/NavBar";
import PageHeader from "../../components/PageHeader";
import PageScreen from "../../components/PageScreen";
import DataView from "../../components/DataView";
import RightModal from "../../components/RightModal/v2";

import { useConfirm } from "material-ui-confirm";

// HOCs
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as alertsActionCreators from "../../data/alerts/actions";
import HeaderButton from "../../components/HeaderButton";

import Moment from "react-moment";
import nativeMoment from "moment-timezone";
import "moment/locale/es";

const Alerts = (props) => {
  const MODAL_MANIFEST = [
    [
      {
        key: "roomId",
        type: "roomPicker",
        label: "Sala",
        help: "Elige una sala virtual donde lanzar la alerta",
      },
    ],
    [
      {
        key: "title",
        multilang: true,
        type: "string",
        label: "Título",
        help: "Título de la alerta",
      },
    ],
    [
      {
        key: "body",
        multilang: true,
        type: "text",
        label: "Texto",
        help: "Texto de la alerta",
      },
    ],
  ];
  const MODAL_LANG_MANIFEST = [

  ];

  useEffect(() => {
    props.actions.alerts.findItems({});
  }, []);

  const [currentItem, setCurrentItem] = useState({});
  const [modalOpen, setModalOpen] = useState(false);

  const handleNew = () => {
    setCurrentItem({
    });
    setModalOpen(true);
  };

  const handleEdit = (item) => {
    const newItem = { ...item };

    setCurrentItem(newItem);
    setModalOpen(true);
  };

  const handleClose = () => {
    setCurrentItem({});
    setModalOpen(false);
  };

  const confirm = useConfirm();

  return (
    <Fragment>
      <NavBar
        crumbs={[
          { title: "Apps", path: "/" },
          { title: props.selectedApp.name, path: `/${props.selectedApp.slug}/` },
          { title: "Alertas" },
        ]}
      />
      <PageScreen className="ListPage">
        <PageHeader
          title="Alertas"
          renderActions={() => (
            <Fragment>
              <HeaderButton onClick={handleNew}>
                + Nueva alerta
              </HeaderButton>
            </Fragment>
          )}
        />
        <DataView
          loading={props.alerts.loading}
          items={props.alerts.items}
          columnDefs={[
            { ref: "title", align: "left", style: {width: '30%'} },
            { ref: "room", align: "left" },
            { ref: "visible", align: "left" },
            { ref: "createdAt", align: "left" },
            { ref: "actions", align: "left" },
          ]}
          renderHeader={(ref) => {
            switch (ref) {
              case "title":
                return "Título";
              case "room":
                return "Sala";
              case "visible":
                return "Visible";
              case "createdAt":
                return "Hora";
              case "actions":
                return "Acciones";
              default:
                return null;
            }
          }}
          renderCell={(ref, item) => {
            switch (ref) {
              case "title":
                return (
                  <Fragment>
                    <strong>{item.title.es}</strong>
                    <br />{item.body.es}
                  </Fragment>
                );
              case "room":
                return "Sala A";
              case "visible":
                return item.visible ? <LiveTvIcon fontSize="large" color="primary" /> : '';
              case "createdAt":
                return nativeMoment(item.createdAt).format('L HH:mm');
              case "actions":
                return (
                  <Fragment>
                    <IconButton
                      size="small"
                      aria-label="eye"
                      className="EditButton"
                      onClick={() => {
                        confirm({
                          title: item.visible ? "¿Cancelar alerta?" : "¿Lanzar alerta?",
                          description: item.visible ? `Esta acción cancelará la
                          alerta en la sala especificada.` : `Esta acción lanzará la
                          alerta en la sala especificada.`,
                          confirmationText: item.visible ? "Cancelar" : "Lanzar",
                          confirmationButtonProps: { variant: "contained" },
                          cancellationText: "Cancelar",
                          cancellationButtonProps: { variant: "contained" },
                        })
                          .then(() => {
                            props.actions.alerts.patch(item, { visible: !item.visible });
                          })
                          .catch(() => {});
                      }}
                    >
                      <LiveTvIcon fontSize="small" color={item.visible ? "error" : "primary"} />
                    </IconButton>
                    <IconButton
                      size="small"
                      aria-label="delete"
                      className="EditButton"
                      onClick={() => handleEdit(item)}
                    >
                      <EditIcon fontSize="small" />
                    </IconButton>
                    <IconButton
                      size="small"
                      aria-label="delete"
                      className="DeleteButton"
                      onClick={() => {
                        confirm({
                          title: "¿Eliminar alerta?",
                          description: `Esta acción eliminará por completo la
                          alerta.
                          Esta acción es permenente y no tiene marcha atrás.`,
                          confirmationText: "Eliminar",
                          confirmationButtonProps: { variant: "contained" },
                          cancellationText: "Cancelar",
                          cancellationButtonProps: { variant: "contained" },
                        })
                          .then(() => {
                            props.actions.alerts.remove(item);
                          })
                          .catch(() => {});
                      }}
                    >
                      <DeleteIcon fontSize="small" />
                    </IconButton>
                  </Fragment>
                );
              default:
                return null;
            }
          }}
          empty={{
            title: "Envía alertas a tus usuarios",
            body:
              "Muestra mensajes emergentes en Virtual Venues mediante las alertas.",
            cta: "+ Crear nueva alerta",
            action: handleNew,
          }}
        />
      </PageScreen>
      <RightModal
        newTitle="Crear nueva alerta"
        editTitle="Editar alerta"
        open={modalOpen}
        currentItem={currentItem}
        handleClose={handleClose}
        createAction={props.actions.alerts.create}
        patchAction={props.actions.alerts.patch}
        manifest={MODAL_MANIFEST}
        langManifest={MODAL_LANG_MANIFEST}
      />
    </Fragment>
  );
};

export default connect(
  (state, ownProps) => ({
    selectedApp: state.data.apps.selected,
    alerts: state.data.alerts,
  }),
  (dispatch) => ({
    actions: {
      alerts: bindActionCreators(alertsActionCreators, dispatch),
    },
  })
)(Alerts);
